import { c as _c } from "react/compiler-runtime";
import { BrowseCourseCard, BrowseCourseCarousel, BrowseCourseCarouselConfiguration } from '@udemy-v2/react-browse-course';
import { useDeviceType } from '@udemy-v2/hooks';
import { BrowseEventTrackingProvider, TrackableDiscoveryItem } from '@udemy-v2/react-browse-event-tracking';
import { BrowseCourse } from '@udemy-v2/browse-course';
import { DESKTOP_BROWSE_COURSE_CARD_OPTIONS, DESKTOP_BROWSE_COURSE_CAROUSEL_CONFIGURATION } from './browse-course-carousel-desktop-configuration';
import styles from './browse-course-carousel.module.scss';
interface ResponsiveBrowseCourseCarouselProps<T extends BrowseCourse> {
  courses: TrackableDiscoveryItem<T>[];
  className?: string;
  config?: BrowseCourseCarouselConfiguration;
}

/**
 * CLP adapter around `@udemy-v2/react-browse-course`'s `BrowseCourseCarousel`.
 *
 * Mobile keeps a vertical stack of condensed cards (not achievable via carousel
 * configuration alone). Desktop delegates to the shared carousel with the
 * standard CLP full-width configuration.
 */
export function ResponsiveBrowseCourseCarousel(t0) {
  const $ = _c(9);
  const {
    courses,
    className,
    config
  } = t0;
  const deviceType = useDeviceType();
  if (deviceType === "mobile") {
    let t1;
    if ($[0] !== courses) {
      t1 = courses.map(_temp);
      $[0] = courses;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== className || $[3] !== t1) {
      t2 = <div className={className}>{t1}</div>;
      $[2] = className;
      $[3] = t1;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  const t1 = className ?? styles["margin-top-xs"];
  const t2 = config ?? DESKTOP_BROWSE_COURSE_CAROUSEL_CONFIGURATION;
  let t3;
  if ($[5] !== courses || $[6] !== t1 || $[7] !== t2) {
    t3 = <BrowseCourseCarousel courses={courses} className={t1} configuration={t2} options={DESKTOP_BROWSE_COURSE_CARD_OPTIONS} />;
    $[5] = courses;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function _temp(course, index) {
  return <BrowseEventTrackingProvider key={course.id} browseEventTrackingContext={{
    index
  }}><div className={styles["card-container"]}><BrowseCourseCard course={course} layout="condensed" options={DESKTOP_BROWSE_COURSE_CARD_OPTIONS} /></div></BrowseEventTrackingProvider>;
}